<template>
  <ul class="mobile-togglers">
    <li class="confirm-toggler mobile" @click="$emit('confirm')">
      Confirm Selection
    </li>
    <li
      class="fullscreen-toggler"
      :class="{ shown: fullscreen }"
      @click="$emit('goFullscreen')"
    >
      <svg
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 298.667 298.667"
        style="enable-background:new 0 0 298.667 298.667;"
        xml:space="preserve"
      >
        <polygon
          fill="#fff"
          points="42.667,192 0,192 0,298.667 106.667,298.667 106.667,256 42.667,256"
        />
        <polygon
          fill="#fff"
          points="0,106.667 42.667,106.667 42.667,42.667 106.667,42.667 106.667,0 0,0"
        />
        <polygon
          fill="#fff"
          points="192,0 192,42.667 256,42.667 256,106.667 298.667,106.667 298.667,0"
        />
        <polygon
          fill="#fff"
          points="256,256 192,256 192,298.667 298.667,298.667 298.667,192 256,192"
        />
      </svg>
    </li>
    <li
      class="navbar-toggler"
      :class="{ open: toggled }"
      @click="$emit('toggleToggled')"
    >
      <span class="icon-bar"></span>
      <span class="icon-bar"></span>
      <span class="icon-bar"></span>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'MobileTogglers',
  props: {
    toggled: Boolean,
    fullscreen: Boolean,
  },
};
</script>
